<div class="row fondoColor">
    <div class="col-12">
        <div class="row py-3 px-4">
            <div class="col-12 p-0 mb-3 tituloAgregar">
                <span>Agregar Reseña</span>
            </div>
            <div class="col-12 px-0">
                <div class="row pl-3 mb-3">
                    <app-review-star-item *ngFor="let star of starStates" [state]="star.state" [starID]=star.id
                        [isSelected]="star.isSelected" [isHovered]="star.isHovered" (onHovered)="onStarHovered($event)"
                        (onSelected)="onStarSelected($event)"></app-review-star-item>
                    <div class="col px-0 resetStars" *ngIf="showResetStars">
                        <i class="fas fa-times" (click)="onResetStars()"></i>
                    </div>
                </div>
            </div>
            <div class="col-12 p-0">
                <form [formGroup]="commentForm">
                    <div class="form-group">
                        <textarea class="form-control commentTextArea" id="commentTextArea" formControlName="comment"
                            rows="4" placeholder="Escriba una reseña ..."></textarea>
                    </div>
                </form>
            </div>
            <div class="col-12 px-0 buttonContainter">

                <button class=" btn cm-bg-color-11 px-4 text-white rounded-1" (click)="onClickEnviar($event)"
                    [disabled]="loading">
                    <span *ngIf="!loading"> Enviar reseña </span>
                    <span *ngIf="loading" class="spinner-border spinner-border-sm mx-5" role="status"
                        aria-hidden="true"></span>
                </button>

            </div>
        </div>
    </div>
</div>